import { createEntityHooks } from "../../common/entity";
import sourceCodeState from "./state";

export const { useEntities: useSourceCodes, useEntity: useSourceCode } =
  createEntityHooks({
    entity: sourceCodeState.entity,
    actions: sourceCodeState.actions,
  });
